import React from 'react';
import {RegulationComponentsCommon} from "../../regulation-components-common";
import {
    HeaderWelcomeLoginButtonComponentProps
} from "../../../../components/header/buttons/login-button/header-login-button.component.props";
import {ButtonPreset} from "../../../../basic-ui-components/button/base/button-props.interface";
import {
    HeaderWelcomeRegisterButtonComponentProps
} from "../../../../components/header/buttons/register-button/header-register-button.component.props";

export class OntarioRegulationComponents extends RegulationComponentsCommon {
    renderHeaderLoginButton(props: HeaderWelcomeLoginButtonComponentProps): React.ReactElement {
        const buttonPreset: ButtonPreset = this.services.regulation.shouldEnforceHybridAppForMobileWebOnLoginAttempt()
                                             ? "primary"
                                             : "secondaryInverted";
        return super.renderHeaderLoginButton({
            ...props,
            preset: buttonPreset
        });
    }

    renderHeaderRegisterButton(props: HeaderWelcomeRegisterButtonComponentProps): React.ReactElement {
        const buttonPreset: ButtonPreset = this.services.regulation.shouldEnforceHybridAppForMobileWebOnLoginAttempt()
                                                ? "secondaryInverted"
                                                : "primary";
        return super.renderHeaderRegisterButton({
            ...props,
            preset: buttonPreset
        });
    }
}